<template>
    <div id="workstation-location-page">
        <pre v-if="isDebug">{{
            { scanningForLocations, scanningForLocation }
        }}</pre>
        <div class="top-right">
            <div class="validate-form">
                <ui5-input
                    type="Text"
                    :value="inputNr"
                    :disabled="loading"
                    @input="inputNr = $event.target.value"
                    @keyup.enter="
                        validateProductNr(inputNr);
                        inputNr = '';
                    "
                />
                <ui5-button
                    @click="
                        validateProductNr(inputNr);
                        inputNr = '';
                    "
                    :disabled="loading"
                >
                    <spinner v-if="loading" />
                    <template v-else>
                        {{ trans('pages.workstation_location.validate') }}
                    </template>
                </ui5-button>
            </div>
            <div class="camera-icon">
                <ui5-button
                    @click="scan"
                    :disabled="loading"
                >
                    <i class="fa fa-camera fa-3x" />
                </ui5-button>
            </div>
        </div>
        <ui5-table v-if="locationOptions">
            <ui5-table-column slot="columns">
                <div class="product-column">
                    <ui5-label>&nbsp;</ui5-label>
                </div>
            </ui5-table-column>
            <ui5-table-column
                slot="columns"
                :popin-text="
                    trans('pages.workstation_location.number_of_packages')
                "
            >
                <div class="field">
                    <ui5-label>
                        {{
                            trans(
                                'pages.workstation_location.number_of_packages'
                            )
                        }}
                    </ui5-label>
                    <input
                        @click.stop="() => {}"
                        type="number"
                        v-model="global.colli"
                    />
                </div>
            </ui5-table-column>
            <ui5-table-column
                v-for="(_, index) in [0, 1, 2]"
                :key="'box-column-' + index"
                slot="columns"
                :popin-text="
                    trans('pages.workstation_location.box') + ' ' + (index + 1)
                "
                @click.stop.prevent="() => {}"
            >
                <div class="field">
                    <div class="checkbox-label">
                        <ui5-radio-button
                            value-state="Warning"
                            @change="scanningForLocation = index"
                            :checked="scanningForLocation == index"
                        />
                        <ui5-label>
                            {{ trans('pages.workstation_location.box') }}
                            {{ index + 1 }}
                            <template v-if="scanningForLocations[index]">
                                :
                                {{
                                    locationOptions.find(
                                        (x) =>
                                            scanningForLocations[index] ==
                                            x.value
                                    ).label
                                }}
                            </template>
                        </ui5-label>
                    </div>
                    <select
                        @change="changeStockLocation($event, global, index)"
                    >
                        <option
                            v-for="(option, optionIndex) in locationOptions"
                            :key="'location.top.' + index + '.' + optionIndex"
                            :selected="
                                option.value == global.stockLocations[index]
                            "
                            :value="option.value"
                        >
                            {{ option.label }}
                        </option>
                    </select>
                </div>
            </ui5-table-column>
            <ui5-table-column slot="columns">
                <div class="field">
                    <ui5-label>&nbsp;</ui5-label>
                    <ui5-button
                        @click="apply"
                        :disabled="!products || products.length == 0"
                    >
                        {{ trans('pages.workstation_location.apply') }}
                    </ui5-button>
                </div>
            </ui5-table-column>
            <template v-if="products">
                <ui5-table-row
                    v-for="(product, productIndex) in products"
                    :key="product.productId"
                >
                    <ui5-table-cell>
                        <span>
                            {{ product.productNr }} - {{ product.reference }} -
                            {{ product.customerName }}
                        </span>
                    </ui5-table-cell>
                    <ui5-table-cell>
                        <input
                            type="number"
                            v-model="product.colli"
                        />
                    </ui5-table-cell>
                    <ui5-table-cell
                        v-for="index in [0, 1, 2]"
                        :key="'product-location-' + index"
                    >
                        <select
                            @change="
                                changeStockLocation($event, product, index)
                            "
                        >
                            <option
                                v-for="(option, optionIndex) in locationOptions"
                                :key="
                                    'location.' +
                                    product.productId +
                                    '.' +
                                    index +
                                    '.' +
                                    optionIndex
                                "
                                :selected="
                                    option.value ==
                                    product.stockLocations[index]
                                "
                                :value="option.value"
                            >
                                {{ option.label }}
                            </option>
                        </select>
                    </ui5-table-cell>
                    <ui5-table-cell>
                        <div class="product-actions">
                            <i
                                class="fa fa-remove"
                                @click="$delete(products, productIndex)"
                            />
                        </div>
                    </ui5-table-cell>
                </ui5-table-row>
            </template>
        </ui5-table>
        <div class="bottom-buttons">
            <ui5-button
                @click="process"
                :disabled="!products || !products.length"
            >
                {{ trans('pages.workstation_location.process') }}
            </ui5-button>
        </div>
    </div>
</template>
<script>
import productApi from '../api/product';
import stockLocationApi from '../api/stockLocation';
import Spinner from '../components/loader/Spinner';
import ErrorHelper from '../helpers/ErrorHelper';
import IsDebugMixin from '../mixins/is-debug';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import { productOrLocationMocker } from '../shared/qrMockers';
import _ from 'lodash';
import localization from '../mixins/localization';

export default {
    mixins: [IsDebugMixin, localization],
    components: { Spinner },
    data() {
        return {
            scanningForLocation: 0,
            scanningForLocations: [null, null, null],
            global: {
                colli: '',
                stockLocations: [null, null, null],
            },
            products: null,
            locationOptions: null,
            loading: false,
            inputNr: '',
        };
    },
    mounted() {
        this.products = [];
        this.resetGlobal();
        this.$bus.$on('qr_scanner.on_scan', (key, value) => {
            if (key === 'workpostlocation') {
                this.onScan(value);
            }
        });
        stockLocationApi.fetchAll().then((response) => {
            this.locationOptions = [
                { value: null, label: '───────────' },
                ..._.chain(response.data.data)
                    .map((x) => {
                        return {
                            value: x.ID,
                            label: x.label,
                        };
                    })
                    .sortBy((x) => x.label)
                    .value(),
            ];
        });
    },
    methods: {
        setNextLocation() {
            this.scanningForLocation =
                (this.scanningForLocation + 1) %
                this.scanningForLocations.length;
        },
        process() {
            productApi
                .batchSaveColliAndLocations(this.products)
                .then(() => {
                    showInfoMessage(
                        this.trans(
                            'pages.workstation_location.success.data_saved'
                        )
                    );
                    this.products = [];
                    this.resetGlobal();
                })
                .catch((error) => {
                    showErrorMessage(
                        this.trans(
                            'pages.workstation_location.errors.save_failed',
                            {
                                error: ErrorHelper.parseError(
                                    error.response.data
                                ),
                            }
                        )
                    );
                });
        },
        resetGlobal() {
            this.global = {
                colli: '',
                stockLocations: [null, null, null],
            };
            this.scanningForLocation = 0;
            this.scanningForLocations = [null, null, null];
        },
        apply() {
            this.products.forEach((product) => {
                if (
                    this.global.colli != null &&
                    this.global.colli.toString() != ''
                ) {
                    product.colli = this.global.colli.toString();
                }
                const locations = [...product.stockLocations];
                Object.keys(this.global.stockLocations).forEach((index) => {
                    let value = this.global.stockLocations[index];
                    if (value != null) {
                        value = value.toString();
                        if (value.length) {
                            locations[index] = value;
                        }
                    }
                });
                product.stockLocations = locations;
            });
            this.resetGlobal();
        },
        changeStockLocation($event, product, index) {
            const locations = [...product.stockLocations];
            locations[index] = $event.target.value;
            product.stockLocations = locations;
        },
        validateProductNr(productNr) {
            this.loading = true;
            productApi
                .fetchShallowProduct(productNr.toString().replace(/\D/g, ''))
                .then((response) => {
                    const product = response.data.data;
                    if (
                        this.products.some(
                            (x) => x.productId == product.productId
                        )
                    ) {
                        return showErrorMessage(
                            this.trans(
                                'pages.workstation_location.errors.product_already_in_list',
                                {
                                    productNr: product.productNr,
                                }
                            )
                        );
                    }
                    const newProduct = {
                        productId: product.productId,
                        productNr: product.productNr,
                        reference: product.reference,
                        customerName: product.customerName,
                        colli: product.colli,
                    };

                    const productLocations = [...product.stockLocations];
                    this.scanningForLocations.forEach((locationId, index) => {
                        if (locationId !== null) {
                            productLocations[index] = locationId;
                        }
                    });
                    (newProduct.stockLocations = productLocations),
                        this.products.push(newProduct);
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans(
                            'pages.workstation_location.errors.invalid_product_number'
                        )
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        scan() {
            this.$bus.$emit('qr_scanner.start', 'workpostlocation', {
                singleScan: true,
                defaultCamera: 'front',
                mocker: productOrLocationMocker,
            });
        },
        onScan(value) {
            let decoded = null;
            try {
                decoded = JSON.parse(value);
            } catch (error) {}

            if (decoded && decoded.context === 'product') {
                this.validateProductNr(decoded.productId);
            } else if (decoded && decoded.context === 'stockLocation') {
                this.validateStocklocationId(decoded.stocklocationId);
            } else {
                showErrorMessage(
                    this.trans(
                        'pages.workstation_location.errors.invalid_qr_code'
                    ),
                    null,
                    1500
                );
            }
        },
        validateStocklocationId(stockLocationId) {
            if (this.locationOptions) {
                const option = this.locationOptions.find(
                    (x) => x.value == stockLocationId
                );
                if (!option) {
                    return showErrorMessage(
                        this.trans(
                            'pages.workstation_location.errors.stock_location_not_found'
                        )
                    );
                }
                const locations = [...this.scanningForLocations];
                locations[this.scanningForLocation] = option.value;
                this.scanningForLocations = locations;
                this.products.forEach((product) => {
                    const productLocations = [...product.stockLocations];
                    productLocations[this.scanningForLocation] = option.value;
                    product.stockLocations = productLocations;
                });
                //this.setNextLocation();
            }
        },
    },
};
</script>
